<div class="modal-create-profile-container">
<h2>{{ 'createProfileModal.new_profile' | translate }}</h2>
<p>{{ 'createProfileModal.insert_here' | translate }}</p>
@if (createProfileForm) {
<div class="input-container" nzGutter='16' [formGroup]="createProfileForm">
<div class="container-modal">
<ds-input-text
     nz-col
     [nzXl]="12"
     [nzLg]="24"
     [nzXs]="24"
     [nzMd]="24"
     [control]="createProfileForm.get('name')"
     [placeholder]="'createProfileModal.insert' | translate"
     [label]="'createProfileModal.name' | translate"
>
</ds-input-text>
<ds-input-text
     nz-col
     [nzXl]="12"
     [nzLg]="24"
     [nzXs]="24"
     [nzMd]="24"
     [control]="createProfileForm.get('surname')"
     [placeholder]="'createProfileModal.insert' | translate"
     [label]="'createProfileModal.surname' | translate"
>
</ds-input-text>
</div>
<app-aria-date-picker-field
   nz-col
   [nzXl]="12"
   [nzLg]="24"
   [nzXs]="24"
   [nzMd]="24"
   formControlName="birthdate"
   [placeholder]="'createProfileModal.select_date' | translate"
   [minDate]="startBirthdate"
   [maxDate]="endBirthdate"
   [label]="'createProfileModal.birthdate' | translate"
   mode="single"
   mobileDrawer="auto"
></app-aria-date-picker-field>
<label
   class="checkbox"
   nz-checkbox
   formControlName="calculateTaxcode"
   aria-label="Calcola il codice fiscale automaticamente"
>
   {{ 'createProfileModal.want_calculate_taxcode' | translate }}
</label>
 @if (createProfileForm.get('calculateTaxcode')?.value) {
<div
     class="input-taxcode-container"
     [formGroupName]="'taxcodeSection'"
>
<p>
       {{ 'createProfileModal.complete_for_taxcode' | translate }}
</p>
<div nz-row nzGutter="16" class="taxcode-fields">
<app-aria-autocomplete-field
         nz-col
         [nzXl]="12"
         [nzLg]="24"
         [nzXs]="24"
         [nzMd]="24"
         formControlName="gender"
         [placeholder]="'createProfileModal.select' | translate"
         [label]="'createProfileModal.gender' | translate"
         [options]="genderOptions"
></app-aria-autocomplete-field>
<app-aria-autocomplete-field
         nz-col
         [nzXl]="12"
         [nzLg]="24"
         [nzXs]="24"
         [nzMd]="24"
         formControlName="birthDistrict"
         [placeholder]="'createProfileModal.select' | translate"
         [label]="'createProfileModal.district' | translate"
         [options]="districts"
></app-aria-autocomplete-field>
<app-aria-autocomplete-field
         nz-col
         [nzXl]="12"
         [nzLg]="24"
         [nzXs]="24"
         [nzMd]="24"
         formControlName="birthCity"
         [placeholder]="'createProfileModal.select' | translate"
         [label]="'createProfileModal.cities' | translate"
         [options]="cities"
></app-aria-autocomplete-field>
</div>
     @if (
       createProfileForm.get('taxcode')?.valid &&
       createProfileForm.get('taxcode')?.value
     ) {
<div class="info-message">
<img
           src="/public/assets/images/check-circle-green.svg"
           alt="check circle green"
         />
<div>
<span>
             {{ 'createProfileModal.your_taxcode_is' | translate }}
</span>
<span style="font-weight: 600">
             {{ createProfileForm.get('taxcode')?.value }}
</span>
<span>
             {{ 'createProfileModal.and_auto_completes_in_field' | translate }}
</span>
</div>
</div>
     }
</div>
 }
<ds-input-text
   nz-col
   style="margin-right: 3px"
   [nzXl]="12"
   [nzLg]="24"
   [nzXs]="24"
   [nzMd]="24"
   [control]="createProfileForm.get('taxcode')"
   [placeholder]="'createProfileModal.insert' | translate"
   [label]="'createProfileModal.taxcode' | translate"
></ds-input-text>
 @if (isAdult) {
<ds-input-text
     nz-col
     style="margin-right: 3px"
     [nzXl]="12"
     [nzLg]="24"
     [nzXs]="24"
     [nzMd]="24"
     [control]="createProfileForm.get('phone')"
     [placeholder]="'createProfileModal.insert' | translate"
     [label]="'createProfileModal.phone' | translate"
></ds-input-text>
   @if (
     (createProfileForm.get('phone')?.invalid &&
       createProfileForm.get('phone')?.touched) ||
     createProfileForm.get('phone')?.dirty
   ) {
<div class="error-message">
       @if (createProfileForm.get('phone')?.hasError('required')) {
<span class="error-text">
           {{ 'createProfileModal.phone_required' | translate }}
</span>
       }
       @if (createProfileForm.get('phone')?.hasError('pattern')) {
<span class="error-text">
           {{ 'createProfileModal.phone_invalid' | translate }}
</span>
       }
</div>
   }
 }
 @if (
   !isAdult &&
   createProfileForm.get('legalProtectionMinor') !== null
 ) {
<div class="info-message">
<img
       src="/public/assets/images/check-circle-orange.svg"
       alt="check circle orange"
     />
<div>
<span>
         {{ 'createProfileModal.profile_minor' | translate }}
</span>
</div>
</div>
   @if (createProfileForm.get('legalProtectionMinor')) {
<label
       class="checkbox"
       nz-checkbox
       formControlName="legalProtectionMinor"
       aria-label="Confermo la tutela legale del minore"
>
       {{ 'createProfileModal.confirm_legal_protection' | translate }}
</label>
   }
 }
 @if (isAdult) {
<ds-input-text
     [type]="'email'"
     nz-col
     [nzXl]="12"
     [nzLg]="24"
     [nzXs]="24"
     [nzMd]="24"
     [control]="createProfileForm.get('email')"
     [placeholder]="'createProfileModal.insert' | translate"
     [label]="'createProfileModal.email' | translate"
>
</ds-input-text>
   @if (
     createProfileForm.get('email')?.invalid &&
     createProfileForm.get('email')?.dirty
   ) {
<div class="error-message">
       @if (createProfileForm.get('email')?.hasError('required')) {
<span class="error-text">
           {{ 'createProfileModal.email_required' | translate }}
</span>
       }
       @if (createProfileForm.get('email')?.hasError('email')) {
<span class="error-text">
           {{ 'createProfileModal.email_invalid' | translate }}
</span>
       }
</div>
   }
 }
</div>
}
<div class="container-buttons">
<ds-button
     [text]="'buttons.exit' | translate"
     [styleType]="'empty-main'"
     [width]="'small'"
     (click)="onExit()"
></ds-button>
<ds-button
 [text]="'buttons.send' | translate"
 [width]="'small'"
 (click)="onSend()"
 [isDisabled]="createProfileForm?.invalid"
></ds-button>
</div>
</div>